<ng-container>
  <mat-checkbox
    [(ngModel)]="isChecked"
    [indeterminate]="isIndeterminate"
    (change)="toggleSelect()"
  ></mat-checkbox>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    [class.upside-down]="contextMenuOpen"
    fill="none"
    (click)="onContextMenu($event)"
  >
    <path
      d="M4.80459 6.60153C4.47237 6.26931 3.93374 6.26931 3.60153 6.60153C3.26931 6.93375 3.26931 7.47237 3.60153 7.80459L9.47328 13.6763C9.65203 13.8551 9.94185 13.8551 10.1206 13.6763L15.9924 7.80459C16.3246 7.47237 16.3246 6.93374 15.9924 6.60153C15.6601 6.26931 15.1215 6.26931 14.7893 6.60153L9.79694 11.5939L4.80459 6.60153Z"
      fill="black"
      fill-opacity="0.6"
    />
  </svg>

  <context-menu
    [menuClass]="'external-mam-context-menu'"
    (close)="this.contextMenuOpen = false"
  >
    <ng-template contextMenuItem (execute)="SetSelection('all')"
      >Select All</ng-template
    >
    <ng-template contextMenuItem (execute)="SetSelection('page')"
      >Select this page</ng-template
    >
  </context-menu>
</ng-container>
